import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import store from "../store";
import base from "./../config/base";
import Logger from "../services/logger.js";
import SERVICE_URL, {
    FILE_NAME,
    LOG_TYPE,
    HTTP_CODES,
    WEBSOCKET_READYSTATE
} from "../config/API_DATA";
import { getLogCountFromLocal, setLogCountToLocal, getMultipleErrFromLocal, setMultipleErrToLocal, clearLogCountFromLocal, clearMulErrFromLocal, getAgtLoginResFromLocal, getSysLoginResFromLocal } from './../applocalstorage/localStorage'
import { PATHNAME, COMPONENT_NAME, LOCAL_STORAGE_KEYS } from "../util/constants.js";
import BaseConfiguration from "./../config/base";
import { setContext } from 'apollo-link-context';
import { WebSocketLink } from "apollo-link-ws";
import { split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'
import {
  handleJWT,
} from "./../util/util"
import { i18n } from "./../plugins/i18n.js";
import { getSubscriptionURL} from './../config/env-config'



// HTTP connection to the API
// const httpLink = createHttpLink({
//   // You should use an absolute URL here
//   uri: 'https://gql.b2b.ascent24.io/v1/graphql'
// });
const getHeaders = () => {
  const headers = {};
  //const token = window.localStorage.getItem('apollo-token');
  const token = getJWT();
  if (token) {
    headers.authorization = token;
  }
  return headers;
};

 const subscriptionURL= getSubscriptionURL()
const WSlink = new WebSocketLink({
  uri:subscriptionURL,
  options: {
  
    // lazy: true,
    reconnect: true,
    timeout: 30000,
    connectionParams: () => {
      let token = getHeaders();
      return { headers: token };
    },
  }
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = getJWT();
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token || null,
      },
    };
  });

  
// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const slitLink = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  WSlink,
  // authLink.concat(httpLink)
)

// Cache implementation
const cache = new InMemoryCache()

const client = new ApolloClient({
  link: slitLink,
  cache: new InMemoryCache({
    //addTypename: true
  }),
  connectToDevTools: true,
});
// Create the apollo client
// const apolloClient = new ApolloClient({
//   link: authLink.concat(httpLink), 
//   cache,
//   connectToDevTools: true,
// })
export function reconnect(){
  if(WSlink.subscriptionClient&&!WSlink.subscriptionClient.reconnect){
    WSlink.subscriptionClient.reconnect=true;
  }
}
export function restartWebsockets (isClose) {

  if(WSlink.subscriptionClient&& WSlink.subscriptionClient.client){

//readyState- CONNECTING-	Socket has been created. The connection is not yet open.
  
    if(WSlink.subscriptionClient.client.readyState!=WEBSOCKET_READYSTATE.CONNECTING){
      WSlink.subscriptionClient.client.onclose(isClose,true)
    }

    if(isClose){
      WSlink.subscriptionClient.reconnect=false;
    }
  }

}

export function handleApolloJWT(pError){
  if(pError&&pError.extensions&&pError.extensions.code==HTTP_CODES.SUBSCRIPTION_FAILED&&pError.message.includes(HTTP_CODES.ERROR_JWT.toUpperCase())){
    let jwtErr={
      "status": HTTP_CODES.ERROR_STR,
      "error": [
          {
              "code": HTTP_CODES.ERROR_JWT_01,
              "value":  i18n.tc('loginPg.jwtExpiredValue')
          }
      ]
  }
       handleJWT(jwtErr);
  }
}

function getJWT(){
    let jwtToken = null;
                let agtLogToken = getAgtLoginResFromLocal();
                let sysLogToken = getSysLoginResFromLocal();
                // let token = agtLogToken ? agtLogToken : sysLogToken ? sysLogToken : null;
                let token = agtLogToken ? agtLogToken : (sysLogToken ? sysLogToken : null);
                if (token) {
                    jwtToken = JSON.parse(token);
                    jwtToken =
                        (jwtToken && jwtToken.authorization) ? jwtToken.authorization : null;
                } else {
                    if (store && store.state) {
                        if (store.state.sAgtLogin && store.state.sAgtLogin.signInRes && store.state.sAgtLogin.signInRes.authorization) {
                            jwtToken = store.state.sAgtLogin.signInRes;
                            if (base.isDebug) console.log("from Agent login");
                        } else if (store.state.sSysLogin && store.state.sSysLogin.AdminSignInRes && store.state.sSysLogin.AdminSignInRes.authorization) {
                            jwtToken = store.state.sSysLogin.AdminSignInRes;
                            if (base.isDebug) console.log("from System login");
                        }
                        jwtToken =
                            (jwtToken && jwtToken.authorization) ? jwtToken.authorization : null;
                    }
                }
                return jwtToken ? `Bearer ${jwtToken}` : '';
}

//export default apolloClient;
export default client;